import { render, staticRenderFns } from "./leftAside.vue?vue&type=template&id=82ed17fa&scoped=true"
import script from "./leftAside.vue?vue&type=script&lang=js"
export * from "./leftAside.vue?vue&type=script&lang=js"
import style0 from "./leftAside.vue?vue&type=style&index=0&id=82ed17fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ed17fa",
  null
  
)

export default component.exports